export default __webpack_public_path__ + "static/media/img-new-exchanges-mobile.3d67916b.png";